import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

const GaugeChart = ({ value, color, unit }) => {
  const chartContainerRef = useRef(null);

  useEffect(() => {
    const chartId = `gauge-chart-${Math.floor(Math.random() * 1000000)}`;
    chartContainerRef.current.id = chartId;

    const chart = echarts.init(chartContainerRef.current);

    const option = {
      series: [
        {
          type: 'gauge',
          detail: {
            formatter: `\n${value===0?'':value+unit}`,
            fontSize: 16,
          },
          data: [{ value, name: '' }],
          axisLabel: {
            fontSize: 0,
          },
          axisLine: {
            lineStyle: {
              color: [
                [0, color],
                [value / 100, color],
                [value / 100, "#CCCCCC"],
                [1, "#CCCCCC"],
              ],
            },
          },
          pointer: {
            itemStyle: {
              color: color,
            },
          },
        },
      ],
    };

    chart.setOption(option);

    return () => chart.dispose();
  }, [value, color]);

  return <div ref={chartContainerRef} style={{ width: '100%', height: '190px' }} />;
};

export default GaugeChart;
